module.exports = __webpack_public_path__ + "static/img/bg-en.02518d7e.webp";